import type { CostSummary } from '../types/jobCost';

interface CostSummaryCardProps {
  summary: CostSummary;
}

export function CostSummaryCard({ summary }: CostSummaryCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-[20px] border border-[#d9d9d9] p-4">
      <h3 className="text-[#0A0A9E] font-semibold text-base mb-3">Cost Summary</h3>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <label className="text-xs text-[#84878A] block mb-1">Materials</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalMaterials)}</p>
        </div>

        <div>
          <label className="text-xs text-[#84878A] block mb-1">Payroll</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalPayroll)}</p>
        </div>

        <div>
          <label className="text-xs text-[#84878A] block mb-1">Subcontractor</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalSubcontractor)}</p>
        </div>

        <div>
          <label className="text-xs text-[#84878A] block mb-1">Other</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalOther)}</p>
        </div>
      </div>

      <div className="border-t border-[#d9d9d9] mt-4 pt-4 grid grid-cols-3 gap-4">
        <div>
          <label className="text-xs text-[#84878A] block mb-1">Subtotal</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalAmount)}</p>
        </div>

        <div>
          <label className="text-xs text-[#84878A] block mb-1">Tax</label>
          <p className="text-sm font-semibold">{formatCurrency(summary.totalTax)}</p>
        </div>

        <div>
          <label className="text-xs text-[#84878A] block mb-1">Total</label>
          <p className="text-lg font-bold text-[#0A0A9E]">{formatCurrency(summary.grandTotal)}</p>
        </div>
      </div>
    </div>
  );
}
